document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.search-container');

  containers.forEach(container => {
    const toggle = container.querySelector('.search-toggle');
    const form = container.querySelector('.search-form');
    const input = container.querySelector('input[type="search"]');
    const icon = container.querySelector('.material-symbols-outlined');

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      const newState = !expanded;

      // Update ARIA attributes
      toggle.setAttribute('aria-expanded', newState);
      form.setAttribute('aria-hidden', !newState);

      // Toggle visual class on form
      form.classList.toggle('__hidden', !newState);

      // Toggle class on container for styling
      container.classList.toggle('__open', newState);
      toggle.classList.toggle('__open', newState);
      icon.classList.toggle('close', newState);

      // Manage focus and keyboard access
      if (newState) {
        form.removeAttribute('inert');
        input.focus();
      } else {
        form.setAttribute('inert', '');
      }
    });
  });
});